// extracted by mini-css-extract-plugin
export default {"melodyVideo":"cP-z","isFullWidth":"dP-z","landingPageVideo":"eP-z","play":"fP-z","iframeVideo":"gP-z","playHidden":"hP-z","fullwidth":"iP-z"};